export const mediaQuery = (size) => {
    return `@media (max-width: ${size}px)`
}
